import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { language, translate } from '../../../../_helpers/general.helper';

const SeparatorContainer = styled.div`
  width: 100%;
  height: 20px;
  margin-top: 25px;
  border-bottom: 1px solid
    ${(props) =>
      props.theme.themeColors[props.theme.activeTheme]
        .botChatBubbleBackgroundColor};
  text-align: center;
`;

const SeparatorText = styled.span`
  font-size: 20px;
  color: ${(props) =>
    props.theme.themeColors[props.theme.activeTheme]
      .botChatBubbleBackgroundColor};
  background-color: ${(props) =>
    props.theme.themeColors[props.theme.activeTheme].windowBackgroundColor};
  padding: 0 10px;
`;

function HistorySeparator({ tid }) {
  return (
    <SeparatorContainer>
      <SeparatorText>{translate('most recent', language(tid))}</SeparatorText>
    </SeparatorContainer>
  );
}

const mapStateToProps = (state) => ({
  tid: state.settings.tid,
});

export default connect(mapStateToProps)(HistorySeparator);
